module.exports = __webpack_public_path__ + "img/9788994963266.02fa64ae.jpg";